import PropTypes from 'prop-types';

const MoneyBagSvg = ({ width, height, palette = [] }) => {
  return (
    <svg
      width={`${width || 70}`}
      height={`${height || 70}`}
      viewBox="0 0 70 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath={`url(#clip0_624_12018${width + height})`}>
        <path
          d="M67.9492 57.5586H63.8477L60.0268 55.5078H51.4062L47.3047 57.5586C46.1721 57.5586 45.2539 58.4765 45.2539 59.6094V63.7109C45.2539 64.8435 46.1721 65.7617 47.3047 65.7617H67.9492C69.0818 65.7617 70 64.8435 70 63.7109V59.6094C70 58.4765 69.0818 57.5586 67.9492 57.5586ZM25.8181 20.6445L20.7927 18.5938L25.5715 16.543L28.7435 6.93793C28.9517 6.31312 28.8477 5.6242 28.4591 5.08936C28.0746 4.55465 27.4578 4.23828 26.7969 4.23828H10.3906C9.72973 4.23828 9.11285 4.55465 8.7284 5.08949C8.33984 5.6242 8.23566 6.31313 8.44402 6.93807L12.2932 18.5938L2.26311 40.5575C0.781074 43.862 0 47.6131 0 51.4062C0 65.7617 11.6923 65.7617 18.5938 65.7617C25.4952 65.7617 37.0508 65.7617 37.0508 51.4062C37.0508 47.6131 36.2697 43.862 34.7877 40.5575L25.8181 20.6445ZM67.9492 41.1523H63.8477L60.423 39.1016H50.7586L47.3047 41.1523C46.1721 41.1523 45.2539 42.0703 45.2539 43.2031V47.3047C45.2539 48.4373 46.1721 49.3555 47.3047 49.3555L50.6291 51.4062H59.8972L63.8477 49.3555H67.9492C69.0818 49.3555 70 48.4373 70 47.3047V43.2031C70 42.0703 69.0818 41.1523 67.9492 41.1523Z"
          fill={`url(#paint0_linear_624_12018${width + height})`}
        />
        <path
          d="M25.818 20.6445L24.8942 18.5938L25.5713 16.543H14.9767L7.20618 12.6577C6.19282 12.1591 4.96317 12.5595 4.45444 13.5749C3.94981 14.5883 4.35833 15.82 5.37169 16.3267L9.90583 18.5938L5.37169 20.8608C4.35833 21.3675 3.94981 22.5992 4.45444 23.6126C4.95401 24.609 6.16917 25.0413 7.20618 24.5298L14.9767 20.6445H25.818ZM51.4061 20.6445C52.5397 20.6445 53.4569 19.7273 53.4569 18.5938V14.4922C53.4569 13.3587 52.5397 12.4414 51.4061 12.4414C50.2726 12.4414 49.3553 13.3587 49.3553 14.4922V18.5938C49.3553 19.7273 50.2726 20.6445 51.4061 20.6445ZM59.5372 24.4717L63.086 22.4209C64.0674 21.8541 64.4038 20.5985 63.8351 19.6191C63.2663 18.6318 62.0006 18.2994 61.0352 18.8681L57.4864 20.9189C56.505 21.4858 56.1686 22.7414 56.7373 23.7207C57.311 24.714 58.5747 25.0312 59.5372 24.4717ZM46.0749 23.7207C46.6437 22.7414 46.3072 21.4856 45.3258 20.9189L41.777 18.8681C40.7998 18.3054 39.55 18.6359 38.9772 19.6191C38.4084 20.5985 38.7449 21.8542 39.7262 22.4209L43.275 24.4717C44.2608 25.0376 45.5094 24.6997 46.0749 23.7207ZM27.8782 42.1997C27.5177 41.5529 26.8328 41.1523 26.0918 41.1523H22.2466L20.344 38.0341C19.5991 36.8123 17.5883 36.8123 16.8433 38.0341L14.9406 41.1523H11.0954C10.3544 41.1523 9.66944 41.5529 9.30905 42.1997C8.94456 42.8466 8.95659 43.6378 9.34514 44.2705L11.1917 47.3026L9.34514 50.3408C8.95659 50.9737 8.94456 51.7647 9.30905 52.4115C9.66958 53.0564 10.3544 53.457 11.0954 53.457H14.9406L16.8432 56.5753C17.2158 57.186 17.8767 57.5586 18.5936 57.5586C19.3106 57.5586 19.9715 57.186 20.344 56.5753L22.2466 53.457H26.0918C26.8328 53.457 27.5178 53.0564 27.8782 52.4117C28.2427 51.7649 28.2307 50.9737 27.8421 50.3409L25.9956 47.3028L27.8421 44.2706C28.2307 43.6378 28.2427 42.8467 27.8782 42.1997ZM63.8475 32.9492H43.203C42.0704 32.9492 41.1522 33.8671 41.1522 35V39.1016C41.1522 40.2341 42.0704 41.1523 43.203 41.1523H47.3046H63.8475C64.9801 41.1523 65.8983 40.2341 65.8983 39.1016V35C65.8983 33.8671 64.9801 32.9492 63.8475 32.9492ZM63.8475 49.3555H47.3046H43.203C42.0704 49.3555 41.1522 50.2734 41.1522 51.4062V55.5078C41.1522 56.6404 42.0704 57.5586 43.203 57.5586H47.3046H63.8475C64.9801 57.5586 65.8983 56.6404 65.8983 55.5078V51.4062C65.8983 50.2734 64.9801 49.3555 63.8475 49.3555Z"
          fill={`url(#paint1_linear_624_12018${width + height})`}
        />
      </g>
      <defs>
        <linearGradient
          id={`paint0_linear_624_12018${width + height}`}
          x1="35"
          y1="65.7617"
          x2="35"
          y2="4.23828"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={palette[0]} />
          <stop offset="1" stopColor={palette[1]} />
        </linearGradient>
        <linearGradient
          id={`paint1_linear_624_12018${width + height}`}
          x1="35.0683"
          y1="57.5586"
          x2="35.0683"
          y2="12.4414"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={palette[2]} />
          <stop offset="1" stopColor={palette[3]} />
        </linearGradient>
        <clipPath id={`clip0_624_12018${width + height}`}>
          <rect width="70" height="70" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

MoneyBagSvg.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  palette: PropTypes.arrayOf(PropTypes.string),
};

export default MoneyBagSvg;
